import { Uuid } from "@legacy-megarax/common";
import { MySubscription } from "@legacy-megarax/crm-contracts";
import { List } from "@mui/material";
import React from "react";

import { CustomerChatFeedEntry } from "./CustomerChatFeedEntry";
import { NoThreadsScreen } from "./NoThreadsScreen";

export type ProfileMap = {
  [userId: number]:
    | {
        userId: number;
        name: string;
        pictureUrl: string;
      }
    | undefined;
};

interface Props {
  threads: MySubscription[];
  profiles: ProfileMap;
  customerNames: {
    [customerUuid: Uuid]: string | undefined;
  };

  onCustomerClick: (uuid: Uuid) => void;
}

export const Feed: React.FunctionComponent<Props> = ({ threads, profiles, customerNames, onCustomerClick }) => {
  return threads.length > 0 ? (
    <List>
      {threads.map((thread) => {
        if (thread.threadIdentifier.type === "customer") {
          const customerUuid = thread.threadIdentifier.customerUuid;
          return (
            <CustomerChatFeedEntry
              customerName={customerNames[customerUuid]}
              onClick={() => onCustomerClick(customerUuid)}
              isUnread={thread.unreadMessageCount > 0}
              lastMessage={{
                ...thread.lastMessage,
                userProfile: profiles[thread.lastMessage.userId],
              }}
            />
          );
        }
        return null;
      })}
    </List>
  ) : (
    <NoThreadsScreen />
  );
};
